var webxErrorType;
(function (webxErrorType) {
    webxErrorType["API_NOT_SUPPORT"] = "API_NOT_SUPPORT";
    webxErrorType["API"] = "API";
    webxErrorType["ENV"] = "ENV";
    webxErrorType["WEBX_INIT"] = "WEBX_INIT";
})(webxErrorType || (webxErrorType = {}));
export function webxError({ type, msg, needReport = false }) {
    if (needReport) {
        reportError(type, msg);
    }
    throw Error(`[Webx.js]type:${type};msg:${msg}`);
}
function reportError(type, msg) {
    console.log(type, msg);
}
export { webxErrorType };
